"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === "function";
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return "EagerThenable{" + {
            "-1": "pending",
            0: "resolved",
            1: "rejected"
          }[phase] + "}=" + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === "function" ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

var PADDING = exports.PADDING = {
  default: 28,
  large: 36,
  small: 24
}; // 左右箭头所占宽度
var MODEL = exports.MODEL = { // 默认的配置
  idField: "code",
  showField: "label",
  iconField: "icon",
  deleteIconField: "deleteIcon",
  disableField: "disabled",
  contentField: "content"
};
var POSITIONMAP = {
  "horizontal": {
    "prev": "left", "next": "right",
    "offsetLeft": "offsetLeft", "offsetWidth": "offsetWidth", "width": "width", "scrollWidth": "scrollWidth"
  },
  "vertical": { "prev": "up", "next": "down",
    "offsetLeft": "offsetTop", "offsetWidth": "offsetHeight", "width": "height", "scrollWidth": "scrollHeight"
  }
};
var getPositionMap = exports.getPositionMap = function getPositionMap() {
  var position = arguments.length <= 0 || arguments[0] === undefined ? "top" : arguments[0];

  return POSITIONMAP[isVertical(position) ? 'vertical' : 'horizontal'];
};

/**
 * 如果是要向右滚动, 需要判断是否已经到最后一个tab边界了
 * @param width 传入想要向右滚动的距离
 * @private invisibleRight Tabs 右侧被挡住的内容宽度
 */
var getScrollRight = exports.getScrollRight = function getScrollRight(scrollPage) {
  var width = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];

  if (!scrollPage) return;
  var _scrollPage$pageWidth = scrollPage.pageWidth;
  var pageWidth = _scrollPage$pageWidth === undefined ? 0 : _scrollPage$pageWidth;
  var _scrollPage$translate = scrollPage.translate;
  var translate = _scrollPage$translate === undefined ? 0 : _scrollPage$translate;
  var _scrollPage$totalWidt = scrollPage.totalWidth;
  var totalWidth = _scrollPage$totalWidt === undefined ? 0 : _scrollPage$totalWidt;
  var padding = scrollPage.padding;

  var invisibleRight = totalWidth - padding + translate - pageWidth;
  return translate - Math.min(width, invisibleRight);
};
/**
 * 如果是要向左滚动, 需要判断是否已经到第一个tab边界了
 * @param width 传入想要向左滚动的距离
 */
var getScrollLeft = exports.getScrollLeft = function getScrollLeft(scrollPage) {
  var width = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
  var _scrollPage$translate2 = scrollPage.translate;
  var translate = _scrollPage$translate2 === undefined ? 0 : _scrollPage$translate2;

  return translate + Math.min(-translate, width);
};

/**
 * 获取组件的内联样式 - 宽高
 */
var getSizeValue = exports.getSizeValue = function getSizeValue(value) {
  return isNaN(value) ? value : value + 'px';
};

// 判断是否有上一页
var hasPrev = exports.hasPrev = function hasPrev(scrollPage) {
  var _scrollPage$translate3 = scrollPage.translate;
  var translate = _scrollPage$translate3 === undefined ? 0 : _scrollPage$translate3;

  return translate < 0;
};
// 判断是否有下一页
var hasNext = exports.hasNext = function hasNext(scrollPage) {
  var _scrollPage$translate4 = scrollPage.translate;
  var translate = _scrollPage$translate4 === undefined ? 0 : _scrollPage$translate4;
  var _scrollPage$totalWidt2 = scrollPage.totalWidth;
  var totalWidth = _scrollPage$totalWidt2 === undefined ? 0 : _scrollPage$totalWidt2;
  var _scrollPage$pageWidth2 = scrollPage.pageWidth;
  var pageWidth = _scrollPage$pageWidth2 === undefined ? 0 : _scrollPage$pageWidth2;
  var padding = scrollPage.padding;

  return -translate + pageWidth < totalWidth - padding;
};
// 判断是否是竖向
var isVertical = exports.isVertical = function isVertical(position) {
  return position !== 'top' && position !== 'bottom';
};
// 判断tabs排在后面
var isTabsRight = exports.isTabsRight = function isTabsRight(position) {
  return position !== 'top' && position !== 'left';
};